export function convertToUpperCase(text) {
  if (typeof text !== "string") return text;

  return text
    .split("")
    .map((char) => {
      const code = char.charCodeAt(0);
      if (code >= 0x10d0 && code <= 0x10ff) {
        return String.fromCharCode(code - 0x10d0 + 0x1c90);
      }
      return char?.toUpperCase();
    })
    .join("");
}
